import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheck, FaArrowRight } from 'react-icons/fa';

const SobhaRealty = () => {
  const navigate = useNavigate();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleEnquire = () => {
    navigate('/contact');
  };

  const benefits = [
    {
      title: 'High ROIs',
      description: "Dubai's Avg. Gross Rental Yield:",
      highlight: '7-8%'
    },
    {
      title: 'Zero Tax Benefits',
      description: 'Income Tax | Capital Gains Tax',
      highlight: '0%'
    },
    {
      title: 'Capital Appreciation',
      description: 'Up to',
      highlight: '8% to 10%',
      extra: 'annually'
    },
    {
      title: 'Unmatched Quality',
      description: 'On-Time Delivery Guaranteed',
      highlight: 'Guaranteed'
    },
    {
      title: 'UAE Residential Gold Visa',
      description: 'Up to',
      highlight: '10 years',
      extra: '(renewable)'
    },
    {
      title: 'Stable Economy',
      description: 'Pegged to the US Dollar',
      highlight: 'Stable'
    },
    {
      title: 'VAT Advantage',
      description: 'on Residential Property',
      highlight: '0% VAT',
      small: '(5% VAT Standard Rate)'
    },
    {
      title: 'Safety First',
      description: 'Safest City in the World',
      highlight: 'Safest'
    },
    {
      title: 'World-Class Living',
      description: 'Dubai Ranks',
      highlight: '3rd Best City',
      extra: 'to Live In'
    },
    {
      title: 'World-Class Hub',
      description: 'State-of-the-Art Infrastructure',
      highlight: 'Global Standard',
      extra: 'Healthcare, Education & Telecommunications'
    },
    {
      title: 'Business Hub',
      description: 'Strategic Gateway Between',
      highlight: 'Europe, Asia & Africa',
      extra: 'with 30+ Free Zones'
    },
    {
      title: 'Easily Accessible',
      description: 'Direct Flights to',
      highlight: '240+ Destinations',
      extra: 'from World\'s Busiest Airport'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans pt-32">

      {/* Header Section */}
      <div className="max-w-3xl mx-auto text-center mb-16">
        <h1 className="text-4xl font-display font-bold text-gray-900 sm:text-5xl tracking-tight mb-4">
          Why <span className="text-[#c8a45e]">Dubai?</span>
        </h1>
        <p className="text-xl text-gray-500 font-light">
          Unlock Your Investment Potential in the World's Most Dynamic City
        </p>
        <div className="w-24 h-1 bg-[#c8a45e] mx-auto mt-6 rounded-full"></div>
      </div>

      {/* Benefits Grid */}
      <div className="max-w-7xl mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {benefits.map((benefit, index) => (
          <div
            key={index}
            className="group relative bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-xl hover:border-[#c8a45e]/30 transition-all duration-300 transform hover:-translate-y-1"
          >
            <div className="absolute top-0 right-0 w-24 h-24 bg-[#c8a45e]/5 rounded-bl-[100px] transition-all duration-300 group-hover:bg-[#c8a45e]/10"></div>

            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#c8a45e]/10 text-[#c8a45e] mb-6 group-hover:bg-[#c8a45e] group-hover:text-white transition-colors duration-300">
              <FaCheck className="text-lg" />
            </div>

            <h3 className="text-xl font-display font-bold text-gray-900 mb-3 group-hover:text-[#c8a45e] transition-colors">
              {benefit.title}
            </h3>

            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">
                {benefit.description}
              </p>

              {benefit.highlight && (
                <p className="text-2xl font-bold text-[#c8a45e] mt-2">
                  {benefit.highlight}
                </p>
              )}

              {benefit.extra && (
                <p className="text-sm text-gray-400 mt-1">
                  {benefit.extra}
                </p>
              )}

              {benefit.small && (
                <p className="text-xs text-gray-400 mt-2 italic border-t border-gray-100 pt-2 inline-block">
                  {benefit.small}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <div className="max-w-4xl mx-auto mt-20 text-center bg-white rounded-3xl p-10 md:p-16 shadow-lg border border-gray-100 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#c8a45e] to-[#e4c988]"></div>

        <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-6">
          Ready to Invest in Your Future?
        </h2>
        <p className="text-lg text-gray-500 mb-8 max-w-2xl mx-auto">
          Schedule a free consultation with our property experts to discuss your investment goals.
        </p>

        <button
          onClick={handleEnquire}
          className="inline-flex items-center gap-3 bg-[#0a0a0a] text-white px-8 py-4 rounded-xl font-bold uppercase tracking-widest hover:bg-[#c8a45e] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 group"
        >
          Enquire Now
          <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
        </button>
      </div>

    </div>
  );
};

export default SobhaRealty;
